import { AbstractControl, FormArray, FormControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {

  static late_fee(c: FormControl): ValidationErrors {
    const num = Number(c.value);
    const isValid = !isNaN(num) && num > 0;
    const message = {
      'late_fee': {
        'message': 'The value must be a valid number greater 0 ' // Will changes the error defined in errors helper.
      }
    };
    return isValid ? null : message;
  }

  static total(c: FormControl): ValidationErrors {
    const num = Number(c.value);
    const isValid = !isNaN(num) && num > 0;
    const message = {
      'total': {
        'message': 'The value must be a valid number greater 0 ' // Will changes the error defined in errors helper.
      }
    };
    return isValid ? null : message;
  }

  static templateValidator(control: FormControl): ValidationErrors {
    const template = control.value;
    if (template === 'null' || template === 'Seleccione su plantilla') {
      return { 'templateInvalid': true };
    }
    return null;
  }

  static fileValid(control: FormControl): ValidationErrors {
    const template = control.value;
    if (!template) {
      return { 'templateInvalid': true };
    }
    return null;
  }

  static validateArray(control: FormArray) {
    if (control && control.value.length === 0) {
      return { itemsRequired: true };
    }
    return null;
  }

  static validateNoPreSelect(control: AbstractControl): ValidationErrors | null {
    const selectedValue = control.value;
    if (selectedValue && selectedValue.toLowerCase() === 'elija' || selectedValue && selectedValue.toLowerCase() === 'seleccione' || selectedValue === "") {
      return { invalidDocumentType: true };
    }
    return null;
  }
}